import script from "./functional-location-tree.vue?vue&type=script&setup=true&lang=ts"
export * from "./functional-location-tree.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__